import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { SpeakersManager } from "@/components/admin/SpeakersManager";

export const Route = createFileRoute("/admin/speakers")({
  component: SpeakersPage,
  head: () => ({
    meta: [
      { title: "Speakers — Admin" },
      { name: "description", content: "Manage event speakers" },
    ],
  }),
});

function SpeakersPage() {
  return (
    <AdminLayout>
      <SpeakersManager />
    </AdminLayout>
  );
}
